<ngx-spinner bdColor="rgb(0, 120, 174)" size="medium" color="#f99d31" type="" [fullScreen]="true">
  <img class="loader-img" src='../../../assets/images/learnyhome2.png' />
</ngx-spinner>
